import { render, staticRenderFns } from "./OrdersFBMBlock.vue?vue&type=template&id=67f7c5ac&scoped=true"
import script from "./OrdersFBMBlock.vue?vue&type=script&lang=js"
export * from "./OrdersFBMBlock.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBMBlock.vue?vue&type=style&index=0&id=67f7c5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7c5ac",
  null
  
)

export default component.exports